import { motion, useInView } from "framer-motion";
import { useRef } from "react";

// Technology images
const technologies = [
  {
    title: "Software Defined Vehicles",
    description: "Intelligent, connected, and software-driven transportation solutions.",
    image: "https://customer-assets.emergentagent.com/job_green-tech-hyd/artifacts/lvefqtlr_WhatsApp%20Image%202026-04-06%20at%2011.46.47%20%281%29.jpeg",
    color: "from-blue-900/80",
  },
  {
    title: "Hydrogen Technology",
    description: "Clean hydrogen fuel cell solutions powering the future of mobility.",
    image: "https://images.unsplash.com/photo-1760382738997-921fb7efdd37?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwzfHxoeWRyb2dlbiUyMGZ1ZWwlMjBjZWxsJTIwdGVjaG5vbG9neSUyMGdyZWVuJTIwZW5lcmd5fGVufDB8fHx8MTc3NTU1MDM1MHww&ixlib=rb-4.1.0&q=85",
    color: "from-emerald-900/80",
  },
  {
    title: "Autonomous Vehicles",
    description: "Self-driving technology revolutionizing transportation safety and efficiency.",
    image: "https://images.unsplash.com/photo-1650699060603-5636741760d6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxhdXRvbm9tb3VzJTIwc2VsZiUyMGRyaXZpbmclMjBjYXIlMjB0ZWNobm9sb2d5fGVufDB8fHx8MTc3NTU1MDM1MHww&ixlib=rb-4.1.0&q=85",
    color: "from-violet-900/80",
  },
  {
    title: "Solar Energy",
    description: "Harnessing solar power for sustainable mobility infrastructure.",
    image: "https://images.unsplash.com/photo-1615630859219-0459703c34e6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwzfHxzb2xhciUyMGVuZXJneSUyMHBhbmVscyUyMHJlbmV3YWJsZSUyMHBvd2VyfGVufDB8fHx8MTc3NTU1MDM1MHww&ixlib=rb-4.1.0&q=85",
    color: "from-amber-900/80",
  },
  {
    title: "Drone Technology",
    description: "Unmanned aerial vehicles enabling sustainable last-mile delivery and logistics.",
    image: "https://images.unsplash.com/photo-1753781466620-d2bc4d703b2e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwyfHxkcm9uZSUyMGRlbGl2ZXJ5JTIwdGVjaG5vbG9neXxlbnwwfHx8fDE3NzU1NTIxODV8MA&ixlib=rb-4.1.0&q=85",
    color: "from-cyan-900/80",
  },
  {
    title: "Urban Air Mobility & eVTOL",
    description: "Electric vertical take-off aircraft transforming urban transportation.",
    image: "https://images.unsplash.com/photo-1718453786531-39727b23ae43?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwyfHxhaXIlMjB0YXhpJTIwZmx5aW5nJTIwdmVoaWNsZSUyMGZ1dHVyaXN0aWN8ZW58MHx8fHwxNzc1NTUyMTkxfDA&ixlib=rb-4.1.0&q=85",
    color: "from-indigo-900/80",
  },
  {
    title: "Smart Infrastructure & V2X",
    description: "Vehicle-to-everything communication enabling intelligent road networks.",
    image: "https://images.unsplash.com/photo-1773901211515-098f765b1acf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwyfHxzbWFydCUyMGNpdHklMjBpbmZyYXN0cnVjdHVyZSUyMHRyYWZmaWN8ZW58MHx8fHwxNzc1NTUyMTg1fDA&ixlib=rb-4.1.0&q=85",
    color: "from-teal-900/80",
  },
  {
    title: "Circular Economy in Battery",
    description: "Sustainable battery lifecycle management and recycling solutions.",
    image: "https://images.unsplash.com/photo-1637773339519-679b29199c18?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwxfHxiYXR0ZXJ5JTIwcmVjeWNsaW5nJTIwY2lyY3VsYXIlMjBlY29ub215fGVufDB8fHx8MTc3NTU1MjE4NXww&ixlib=rb-4.1.0&q=85",
    color: "from-green-900/80",
  },
  {
    title: "Connected Vehicles",
    description: "IoT-enabled vehicles with seamless connectivity and data exchange.",
    image: "https://images.unsplash.com/photo-1726794624054-bdfd4f4cb726?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxjb25uZWN0ZWQlMjBjYXIlMjB2ZWhpY2xlJTIwdGVjaG5vbG9neSUyMElvVHxlbnwwfHx8fDE3NzU1NTIxOTF8MA&ixlib=rb-4.1.0&q=85",
    color: "from-purple-900/80",
  },
  {
    title: "Smart City Traffic Optimisation",
    description: "AI-powered traffic management for reduced congestion and emissions.",
    image: "https://images.unsplash.com/photo-1699602050604-698045645108?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHxzbWFydCUyMGNpdHklMjBpbmZyYXN0cnVjdHVyZSUyMHRyYWZmaWN8ZW58MHx8fHwxNzc1NTUyMTg1fDA&ixlib=rb-4.1.0&q=85",
    color: "from-rose-900/80",
  },
  {
    title: "Bio Fuels",
    description: "Renewable biological fuels for sustainable transportation alternatives.",
    image: "https://images.unsplash.com/photo-1622322977884-6e76ff00fa44?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwyfHxiaW9mdWVsJTIwZ3JlZW4lMjBmdWVsJTIwc3VzdGFpbmFibGV8ZW58MHx8fHwxNzc1NTUyMTkyfDA&ixlib=rb-4.1.0&q=85",
    color: "from-lime-900/80",
  },
];

const TechnologyShowcase = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section
      id="technology"
      ref={ref}
      data-testid="technology-section"
      className="py-20 md:py-32 bg-stone-900"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center max-w-2xl mx-auto mb-16"
        >
          <span className="text-sm font-semibold uppercase tracking-[0.2em] text-emerald-400 mb-4 block">
            Key Focus Areas
          </span>
          <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-white mb-4 tracking-tight">
            Technology Domains
          </h2>
          <p className="text-stone-400 leading-relaxed">
            Driving innovation across multiple sustainable mobility technologies
            for a greener future.
          </p>
        </motion.div>

        {/* Technology Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {technologies.map((tech, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ delay: index * 0.1, duration: 0.6 }}
              className="relative rounded-2xl overflow-hidden group cursor-pointer"
              data-testid={`technology-card-${index}`}
            >
              <img
                src={tech.image}
                alt={tech.title}
                className="w-full h-56 md:h-64 object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              <div className={`absolute inset-0 bg-gradient-to-r ${tech.color} via-stone-900/50 to-transparent flex items-center`}>
                <div className="p-6 max-w-xs">
                  <h3 className="font-heading text-xl font-semibold text-white mb-2">
                    {tech.title}
                  </h3>
                  <p className="text-stone-300 text-sm leading-relaxed">
                    {tech.description}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TechnologyShowcase;
